// UserMaterialTemplateコンポーネントをインポート
// ユーザー向けの「資料ページ」用テンプレートとして使用
import UserMaterialTemplate from "../templates/UserMaterialTemplate";

/**
 * UserMaterialPageコンポーネント
 * ユーザー向けの「資料ページ」を表示するためのコンポーネント
 * UserMaterialTemplateを利用して資料表示画面を構築
 */
const UserMaterialPage = () => {

    // 資料ページテンプレートをレンダリング
    // 特別なプロパティを渡さず、UserMaterialTemplateをそのまま利用
    return (
        <UserMaterialTemplate />
    );
}

// UserMaterialPageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default UserMaterialPage;
